import { render, staticRenderFns } from "./wageLevel.vue?vue&type=template&id=27ae84bd&"
import script from "./wageLevel.vue?vue&type=script&lang=js&"
export * from "./wageLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports